// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TonjeImage_wrapper__2Qdir","round":"TonjeImage_round__2OVTx"};